import { useEffect, useState } from "react";
import Pagination from "./Pagination";
import {
  ApproveWalletProvider,
  getProviderWalletReport,
} from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import UploadBalance from "./UploadBalance";
import { FcApprove, FcDisapprove } from "react-icons/fc";
import Modal from "./Modal";
import Spinner from "../../Spin/Spinner";
import { toast } from "react-toastify";

const ProviderWalletTable = () => {
  const token = useSelector((store) => store.userReducer.token);

  const [loading, setLoading] = useState(false); 
  const [actionLoading, setActionLoading] = useState(false); 
  const [tableData, setTableData] = useState({ data: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isUploadOpen, setIsUploadOpen] = useState(false);

  const [modalData, setModalData] = useState({
    isOpen: false,
    id: null,
    status: "",
  });

  const getProviderWalletData = async () => {
    setLoading(true);
    try {
      const response = await getProviderWalletReport(token, currentPage);
      setTableData(response.data);
      setTotalPages(response.data.totalPages);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleConfirm = async () => {
    setActionLoading(true);
    try {
      await ApproveWalletProvider(token, {
        id: modalData.id,
        status: modalData.status,
      });

      toast.success(`Wallet ${modalData.status.toLowerCase()} successfully`);
      setModalData({ isOpen: false, id: null, status: "" });
      getProviderWalletData();
    } catch (err) {
      toast.error("Failed to update wallet status");
    } finally {
      setActionLoading(false);
    }
  };

  const handleCancel = () => {
    if (actionLoading) return;
    setModalData({ isOpen: false, id: null, status: "" });
  };


  useEffect(() => {
    if (token) getProviderWalletData();
  }, [currentPage, token]);


  return (
    <div className="settlement-report-container">
      <div className="settlement-report-excel">
        <div className="settlement-report-title">Provider Wallet Report</div>
        <button
          className="report-add-button"
          onClick={() => setIsUploadOpen(true)}
          disabled={loading || actionLoading}
        >
          Upload Balance
        </button>
      </div>

      <div className="settlement-report-table-wrapper">
        <table className="settlement-report-table">
          <thead>
            <tr>
              <th>Provider Name</th>
              <th>Org Name</th>
              <th>Upload Amount</th>
              <th>Provider API Balance</th>
              <th>Status</th>
              <th>Upload By</th>
              <th>Approved By</th>
              <th>Created At</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="9">Loading...</td>
              </tr>
            ) : tableData.data?.length > 0 ? (
              tableData.data.map((row, i) => (
                <tr key={i}>
                  <td>{row.pg}</td>
                  <td>{row.orgName}</td>
                  <td>{row.uploadAmount}</td>
                  <td>{row.providerBalance}</td>
                  <td>{row.status}</td>
                  <td>{row.createdBy}</td>
                  <td>{row.approvedBy || "N/A"}</td>
                  <td>
                    {new Date(row.createdAt).toLocaleDateString("en-GB")}{" "}
                    {new Date(row.createdAt).toLocaleTimeString("en-GB", {
                      hour12: true,
                    })}
                  </td>

                  <td>
                    {row.status === "PENDING" ? (
                      <div style={{ display: "flex", gap: "10px" }}>
                        <button
                          className="approve-btn"
                          disabled={actionLoading}
                          onClick={() =>
                            setModalData({
                              isOpen: true,
                              id: row.id,
                              status: "APPROVED",
                            })
                          }
                          title="Approve"
                        >
                          <FcApprove size={28} />
                        </button>

                        <button
                          className="approve-btn"
                          disabled={actionLoading}
                          onClick={() =>
                            setModalData({
                              isOpen: true,
                              id: row.id,
                              status: "REJECTED",
                            })
                          }
                          title="Reject"
                        >
                          <FcDisapprove size={28} />
                        </button>
                      </div>
                    ) : (
                      "Already Approved"
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9">No Data Found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Pagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages}
      />

      {isUploadOpen && (
        <UploadBalance
          onClose={() => setIsUploadOpen(false)}
          onSuccess={getProviderWalletData}
        />
      )}

      {modalData.isOpen && (
        <Modal
          message={`Are you sure you want to mark this Wallet as ${modalData.status}?`}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
          loading={actionLoading}
        />
      )}

      {(loading || actionLoading) && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default ProviderWalletTable;
